<template>
  <div class="input__w">
    <div class="input">
      <slot name="icon" />
      <input
        v-model="inputValue"
        class="input__field"
        :type="getType"
        :inputmode="inputMode"
        :name="name"
        :disabled="disabled"
        :autocomplete="autocomplete"
        :class="[
          { filled: inputValue },
          { error: undefined !== errors || customError },
        ]"
        @blur="onChange"
        @input="onInput"
        @change="onChange"
      />
      <span class="input__caption" :class="{ required }">
        {{ _T(caption) }}
      </span>
      <div
        v-if="'password' === type"
        class="input__show-password"
        @click="toggleShowPassword"
      >
        <img
          v-show="!isPasswordShown"
          src="~~/assets/icons/eye-off.svg"
          alt="show password"
        />
        <img
          v-show="isPasswordShown"
          src="~~/assets/icons/eye-on.svg"
          alt="hide password"
        />
      </div>
      <div
        v-show="undefined !== errors || customError"
        class="input__error-img"
      >
        <img src="~/assets/icons/error-input.svg" alt="error attention" />
      </div>
    </div>
    <div
      v-show="undefined !== errors || customError"
      class="input__error-caption-w"
    >
      <p v-if="null !== customError">
        {{ customError }}
      </p>
      <p v-else>
        <template v-for="error in errors">
          {{ error }}
        </template>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDebounceFn } from "@vueuse/core";
import { FORM_INJECTION_KEY } from "~/nuxt_modules/common/constants/index.js";

enum InputMode {
  text = "text",
  number = "numeric",
  email = "email",
  tel = "tel",
  url = "url",
  search = "search",
}

const props = defineProps({
  name: { type: String, required: true },
  type: { type: String, required: false, default: "text" },
  autocomplete: { type: String, required: false, default: "no" },
  caption: { type: String, required: true },
  customError: { required: false, default: null },
  required: { type: Boolean, required: false, default: true },
  disabled: { type: Boolean, required: false, default: false },
});

const inputValue = defineModel({
  set(value) {
    if (0 !== value.length) {
      return value;
    }
  },
});

const isPasswordShown = ref(false);

const getType = computed(() => {
  if ("password" === props.type) {
    return isPasswordShown.value ? "text" : "password";
  }

  return props.type;
});

const inputMode = computed((): InputMode | undefined => {
  return InputMode[props.type] ?? undefined;
});

/*
Получаем набор ошибок с формы и достаем их по ключу(name) инпута.
validateField - для запуска валидации текущего инпута
 */
const { errors: formErrors, validateField } = inject(FORM_INJECTION_KEY);
const errors = computed(() => {
  return formErrors?.value[props.name];
});

function onChange() {
  validateField(props.name);
}

const onInput = useDebounceFn(() => {
  validateField(props.name);
}, 300);

function toggleShowPassword() {
  isPasswordShown.value = !isPasswordShown.value;
}
</script>

<style lang="scss" scoped></style>
